module.exports = __webpack_public_path__ + "img/pix.c5459201.svg";